export default function Matplotlib_Subplot() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MatplotlibSubplot Component</h1>
      <p>This is the MatplotlibSubplot component.</p>
    </div>
  );
}
